import BigTitle from './BigTitle';

export default BigTitle;